const sanatizeName = (name, length = 26) => {
  if (name.length >= length) {
    name = name.substring(0, 8) + '...' + name.substring(name.length - 8);
  }
  return name;
};

export { sanatizeName };
